import { North } from "@hackthenorth/north";
import React from "react";
import ReactDOM from "react-dom";

import GlobalStyles from "src/shared/components/GlobalStyles";
import themeDef from "src/theme";
import Maintenance from "src/views/maintenance";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "north.js/dist/style.css";

// Flip this to true to close the platform and serve the maintenance page on
// every route instead of <App />. Keeps router, auth and HackerAPI out of
// the bundle entirely while enabled.
const MAINTENANCE_MODE = true;

ReactDOM.render(
  MAINTENANCE_MODE ? (
    <North themeDefinition={themeDef}>
      <GlobalStyles />
      <Maintenance />
    </North>
  ) : (
    <App />
  ),
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
